(function (root, factory) {
  "use strict";

  var api = factory();

  if (root) {
    root.AnywellYS16FamilyReviewCore = api;
  }

  if (typeof module === "object" && module.exports) {
    module.exports = api;
  }
})(typeof window !== "undefined" ? window : null, function () {
  "use strict";

  var VIDEO_LINK_SELECTOR = [
    ".jdgm-rev__vids a",
    "a.jdgm-rev__video",
    "a.jdgm-rev__video-link",
    "a.jdgm-rev__pic-link--video"
  ].join(",");

  var VIDEO_IFRAME_SELECTOR = [
    ".jdgm-rev__vids iframe",
    ".jdgm-rev__video iframe",
    ".jdgm-rev__video-container iframe",
    ".jdgm-rev__video-wrapper iframe",
    ".jdgm-video iframe"
  ].join(",");

  var IMAGE_ELEMENT_SELECTOR = [
    ".jdgm-rev__pics img",
    ".jdgm-rev__pics-wrapper img",
    ".jdgm-rev__picture img",
    "img.jdgm-rev__pic-img",
    "a.jdgm-rev__pic-link img"
  ].join(",");

  var IMAGE_LINK_SELECTOR = [
    ".jdgm-rev__pics a",
    ".jdgm-rev__pics-wrapper a",
    ".jdgm-rev__picture a",
    "a.jdgm-rev__pic-link"
  ].join(",");

  var VIDEO_SCOPE_SELECTOR = [
    ".jdgm-rev__vids",
    ".jdgm-rev__video",
    ".jdgm-rev__video-container",
    ".jdgm-rev__video-wrapper",
    ".jdgm-video",
    ".jdgm-vid-player[data-external-id]",
    ".jdgm-rev__video-link",
    ".jdgm-rev__pic-link--video",
    "[data-video-id]",
    "[data-video-url]"
  ].join(",");

  var VERIFIED_BADGE_SELECTOR = ".jdgm-rev__buyer-badge";

  function textFrom(card, selector) {
    var node = card.querySelector(selector);
    return node ? String(node.textContent || "").replace(/\s+/g, " ").trim() : "";
  }

  function dateFrom(card) {
    var node = card.querySelector(".jdgm-rev__timestamp, time");
    if (!node) return "";
    return String(
      node.getAttribute("data-content") ||
      node.getAttribute("datetime") ||
      node.textContent ||
      ""
    ).trim();
  }

  function attributeValue(node, name) {
    var value = node.getAttribute(name);
    return value === null ? "" : String(value).trim();
  }

  function addResource(resources, kind, value) {
    if (value) resources.add(kind + ":" + value);
  }

  function matchingElements(card, selector) {
    var elements = Array.from(card.querySelectorAll(selector));
    if (card.matches(selector)) elements.unshift(card);
    return elements;
  }

  function collectVideoResources(card) {
    var resources = new Set();

    card.querySelectorAll("video").forEach(function (video) {
      addResource(resources, "video-src", attributeValue(video, "src"));
      video.querySelectorAll("source").forEach(function (source) {
        addResource(resources, "video-source", attributeValue(source, "src"));
      });
    });

    card.querySelectorAll(VIDEO_LINK_SELECTOR).forEach(function (link) {
      addResource(resources, "video-link", attributeValue(link, "href"));
    });

    card.querySelectorAll(VIDEO_IFRAME_SELECTOR).forEach(function (iframe) {
      addResource(resources, "video-iframe", attributeValue(iframe, "src"));
    });

    matchingElements(card, "[data-video-id]").forEach(function (node) {
      addResource(resources, "video-id", attributeValue(node, "data-video-id"));
    });

    matchingElements(card, "[data-video-url]").forEach(function (node) {
      addResource(resources, "video-url", attributeValue(node, "data-video-url"));
    });

    matchingElements(card, ".jdgm-vid-player[data-external-id]").forEach(function (node) {
      addResource(resources, "video-external-id", attributeValue(node, "data-external-id"));
    });

    return Array.from(resources).sort();
  }

  function isVideoScoped(node) {
    return Boolean(node.closest(VIDEO_SCOPE_SELECTOR));
  }

  function collectImageResources(card) {
    var resources = new Set();

    card.querySelectorAll(IMAGE_ELEMENT_SELECTOR).forEach(function (image) {
      if (isVideoScoped(image)) return;
      addResource(resources, "image-src", attributeValue(image, "src"));
      addResource(resources, "image-data-src", attributeValue(image, "data-src"));
    });

    card.querySelectorAll(IMAGE_LINK_SELECTOR).forEach(function (link) {
      if (isVideoScoped(link)) return;
      addResource(resources, "image-link", attributeValue(link, "href"));
    });

    matchingElements(card, "[data-image-id]").forEach(function (node) {
      if (isVideoScoped(node)) return;
      addResource(resources, "image-id", attributeValue(node, "data-image-id"));
    });

    return Array.from(resources).sort();
  }

  function identityFor(card, sourceProductId, author, title, date, body, mediaSignature) {
    return card.getAttribute("data-review-id") ||
      card.getAttribute("data-review-uuid") ||
      card.id ||
      "fallback:" + JSON.stringify([
        sourceProductId == null ? "" : String(sourceProductId),
        author,
        title,
        date,
        body,
        mediaSignature
      ]);
  }

  function parseReviewFragment(documentRef, html, sourceProductId) {
    var template = documentRef.createElement("template");
    template.innerHTML = typeof html === "string" ? html : "";

    var reviews = template.content.querySelector(".jdgm-rev-widg__reviews");
    if (!reviews) return [];

    return Array.from(reviews.querySelectorAll(".jdgm-rev")).reduce(function (records, card, sourceOrder) {
      var scoreNode = card.matches("[data-score]") ? card : card.querySelector("[data-score]");
      var rating = scoreNode ? Number(scoreNode.getAttribute("data-score")) : NaN;
      var title = textFrom(card, ".jdgm-rev__title");
      var body = textFrom(card, ".jdgm-rev__body");
      var author = textFrom(card, ".jdgm-rev__author");
      var date = dateFrom(card);
      var videoResources = collectVideoResources(card);
      var imageResources = collectImageResources(card);
      var allMediaResources = videoResources.concat(imageResources).sort();
      var mediaSignature = allMediaResources.length ? JSON.stringify(allMediaResources) : "";
      var hasVideo = videoResources.length > 0;
      var hasImage = imageResources.length > 0;

      if (!Number.isInteger(rating) || rating < 1 || rating > 5) return records;
      if (!title && !body && !hasVideo && !hasImage) return records;

      if (hasVideo || hasImage) {
        card.classList.add("jdgm-rev--has-media");
      }

      records.push({
        id: identityFor(card, sourceProductId, author, title, date, body, mediaSignature),
        rating: rating,
        title: title,
        body: body,
        author: author,
        date: date,
        verified: Boolean(card.querySelector(VERIFIED_BADGE_SELECTOR)) ||
          card.getAttribute("data-verified-buyer") === "true",
        hasVideo: hasVideo,
        hasImage: hasImage,
        html: card.outerHTML,
        sourceProductId: sourceProductId,
        sourceOrder: sourceOrder
      });

      return records;
    }, []);
  }

  function mediaRank(record) {
    if (record.hasVideo) return 0;
    if (record.hasImage) return 1;
    return 2;
  }

  function usefulTextLength(record) {
    return String(record.title || "").trim().length + String(record.body || "").trim().length;
  }

  function dateValue(record) {
    var parsed = Date.parse(record.date || "");
    return Number.isFinite(parsed) ? parsed : -Infinity;
  }

  function normalizedSemanticValue(value) {
    var normalized = String(value == null ? "" : value);
    if (typeof normalized.normalize === "function") normalized = normalized.normalize("NFKC");
    return normalized
      .toLowerCase()
      .replace(/[\u2018\u2019]/g, "'")
      .replace(/\s+/g, " ")
      .trim();
  }

  function semanticIdentityFor(record) {
    var reviewId = String(record.id == null ? "" : record.id).trim();
    var sourceProductId = normalizedSemanticValue(record.sourceProductId);
    var author = normalizedSemanticValue(record.author);
    var title = normalizedSemanticValue(record.title);
    var body = normalizedSemanticValue(record.body);

    if (!/^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(reviewId)) return "";
    if (!sourceProductId || !author || (!title && !body)) return "";
    return JSON.stringify([sourceProductId, Number(record.rating) || 0, author, title, body]);
  }

  function compareRecords(left, right) {
    return mediaRank(left) - mediaRank(right) ||
      Number(Boolean(right.verified)) - Number(Boolean(left.verified)) ||
      usefulTextLength(right) - usefulTextLength(left) ||
      dateValue(right) - dateValue(left) ||
      Number(left.sourceOrder || 0) - Number(right.sourceOrder || 0);
  }

  function dedupeAndRank(records) {
    var seenIds = new Set();
    var uniqueById = [];

    records.forEach(function (record) {
      if (seenIds.has(record.id)) return;
      seenIds.add(record.id);
      uniqueById.push(record);
    });

    var seenContent = new Set();
    return uniqueById.sort(compareRecords).filter(function (record) {
      var semanticIdentity = semanticIdentityFor(record);
      if (!semanticIdentity) return true;
      if (seenContent.has(semanticIdentity)) return false;
      seenContent.add(semanticIdentity);
      return true;
    });
  }

  function computeAggregate(records) {
    var distribution = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
    var total = 0;

    records.forEach(function (record) {
      distribution[record.rating] += 1;
      total += record.rating;
    });

    return {
      count: records.length,
      average: records.length ? total / records.length : 0,
      distribution: distribution
    };
  }

  function getBatchBounds(visible, total, batchSize) {
    var safeTotal = Math.max(0, Math.floor(Number(total) || 0));
    var safeVisible = Math.min(safeTotal, Math.max(0, Math.floor(Number(visible) || 0)));
    var safeBatchSize = Math.max(1, Math.floor(Number(batchSize === undefined ? 12 : batchSize) || 12));

    var end = Math.min(safeTotal, safeVisible + safeBatchSize);

    return {
      start: safeVisible,
      end: end,
      complete: end >= safeTotal
    };
  }

  return {
    parseReviewFragment: parseReviewFragment,
    dedupeAndRank: dedupeAndRank,
    computeAggregate: computeAggregate,
    getBatchBounds: getBatchBounds
  };
});
